import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';
const SvgCheckBoxOutlineBlankOutlined = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M18 5a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1zm0-2H6Q3 3 3 6v12q0 3 3 3h12q3 0 3-3V6q0-3-3-3"
    }));
export default SvgCheckBoxOutlineBlankOutlined;
